<template>
	<div v-if="props.layout == 'Standard'">
		<div class="tile-scroller-container buttons-bottom">
			<div ref="tileScrollerWrapper" class="tile-scroller-wrapper">
				<div ref="tileScrollerElement" class="tile-scroller" :style="{ transition: 'all 0.5s ease', transform: `translate(${translate})` }" @transitionend="handleTransitionEnd" @mousedown="handleMouseDown" @mouseleave="handleMouseUp" @mousemove="handleMouseMove" @mouseup="handleMouseUp">
					<div class="game-tile Standard" v-for="(data, index) in itemList" :key="index">
						<div class="game-tile-image bordered-item">
							<div class="tile-image bordered-item-wrapper">
								<img v-if="data.TileImageUrl" :src="data.TileImageUrl" :alt="data.TileImageAltText" />
							</div>
						</div>
						<div class="game-tile-content-wrapper">
							<div class="game-tile-header d-flex">
								<div class="pill date">{{ data.GameDateOverride != '' ? data.GameDateOverride : data.GameDate }}</div>
								<div class="pill tagged" v-if="data.GameOverrideTag" :style="{ backgroundColor: data.GameOverrideTagBGColour }">
									{{ data.GameOverrideTag }}
								</div>
								<div class="pill sold-out" v-if="data.GameSoldOutTag || data.PackageSoldOutTag">Sold out</div>
								<div class="pill coming-soon" v-else-if="data.GameComingSoonTag || data.PackageComingSoonTag">Coming soon</div>
							</div>
							<div class="game-tile-content" v-html="data.TileContent"></div>
							<div class="game-tile-buttons d-flex flex-v-centre">
								<div class="btn btn-text" v-if="data.TileModalContent" @click="showDialog(data)">Learn more</div>
								<a class="btn" :href="data.Url">Learn More</a>
							</div>
						</div>
					</div>

					<div class="game-tile Standard custom-tile" v-if="props.customTile">
						<div class="game-tile-image bordered-item">
							<div class="tile-image bordered-item-wrapper">
								<img v-if="props.customImage != ''" :src="props.customImage" />
							</div>
						</div>
						<div class="game-tile-content-wrapper">
							<div class="game-tile-content" v-html="props.customTitle"></div>
							<div class="game-tile-buttons d-flex flex-v-centre">
								<a class="btn" :href="props.customLink">{{ props.customLinkName != '' ? props.customLinkName : 'Learn more' }}</a>
							</div>
						</div>
					</div>

				</div>
				<div class="tile-scroller-controls">
					<button class="slider-prev-button" @click="prev" :disabled="isFirstGameTileVisible"></button>
					<button class="slider-next-button" @click="next" :disabled="isLastGameTileVisible"></button>
				</div>
			</div>
		</div>
	</div>
	<div class="game-tile-list-wrapper d-flex flex-wrap" v-else-if="props.layout == 'Alternative'">
		<div class="tile-scroller-container buttons-bottom">
			<div ref="tileScrollerWrapper" class="tile-scroller-wrapper">
				<div ref="tileScrollerElement" class="tile-scroller" :style="{ transition: 'all 0.5s ease', transform: `translate(${translate})` }" @transitionend="handleTransitionEnd" @mousedown="handleMouseDown" @mouseleave="handleMouseUp" @mousemove="handleMouseMove" @mouseup="handleMouseUp">
					<div class="game-tile Alternative" v-for="(data, idx) in itemList" :key="idx">
						<div class="bordered-item">
							<div class="bordered-item-wrapper">
								<div class="alt-game-tile-wrapper">
									<div class="tile-image" v-if="data.TileImageUrl">
										<img :src="data.TileImageUrl" :alt="data.TileImageAltText" />
									</div>
									<div class="game-tile-content-wrapper">
										<div class="game-tile-header d-flex">
											<div class="pill date">{{ data.GameDateOverride != '' ? data.GameDateOverride : data.GameDate }}</div>
											<div class="pill tagged" v-if="data.GameOverrideTag" :style="{ backgroundColor: data.GameOverrideTagBGColour }">
												{{ data.GameOverrideTag }}
											</div>
											<div class="pill sold-out" v-if="data.GameSoldOutTag">Sold out</div>
											<div class="pill coming-soon" v-else-if="data.GameComingSoonTag">Coming soon</div>
										</div>
										<div class="game-tile-content" v-html="data.TileContent"></div>
									</div>
									<div class="game-tile-buttons d-flex flex-v-centre">
										<a class="btn" :href="data.Url">Learn More</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="tile-scroller-controls">
					<button class="slider-prev-button" @click="prev" :disabled="isFirstGameTileVisible"></button>
					<button class="slider-next-button" @click="next" :disabled="isLastGameTileVisible"></button>
				</div>
			</div>
		</div>
	</div>
	<div class="game-tile-list-wrapper d-flex flex-wrap" v-else-if="props.layout == 'AlternativeNoScroll'">
		<div class="game-tile Alternative no-scroll" v-for="(data, idx) in itemList" :key="idx">
			<div class="bordered-item">
				<div class="bordered-item-wrapper">
					<div class="alt-game-tile-wrapper">
						<div class="tile-image" v-if="data.TileImageUrl">
							<img :src="data.TileImageUrl" :alt="data.TileImageAltText" />
						</div>
						<div class="game-tile-content-wrapper">
							<div class="game-tile-header d-flex">
								<div class="pill date">{{ data.GameDateOverride != '' ? data.GameDateOverride : data.GameDate }}</div>
								<div class="pill tagged" v-if="data.GameOverrideTag" :style="{ backgroundColor: data.GameOverrideTagBGColour }">
									{{ data.GameOverrideTag }}
								</div>
								<div class="pill sold-out" v-if="data.GameSoldOutTag || data.PackageSoldOutTag">Sold out</div>
								<div class="pill coming-soon" v-else-if="data.GameComingSoonTag || data.PackageComingSoonTag">Coming soon</div>
							</div>
							<div class="game-tile-content" v-html="data.TileContent"></div>
						</div>
						<div class="game-tile-buttons d-flex flex-v-centre">
							<a class="btn" :href="data.Url">Learn More</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<Dialog v-model:visible="dialogVisible" modal dismissableMask :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
		<template #container="{ closeCallback }">
			<div v-if="dialogItem" class="dialog-wrapper">
				<div class="bordered-item">
					<div class="bordered-item-wrapper">
						<Button type="button" label="" severity="secondary" @click="closeCallback"></Button>
						<div class="tile-modal-content-container" v-html="dialogItem.TileModalContent"></div>
					</div>
				</div>
			</div>
		</template>
	</Dialog>
</template>

<script lang="ts" setup>
	import type { GameTileItemModel } from '@/types/GameTileItemModel';
	import { useResizeObserver } from '@vueuse/core';
	import { first, last } from 'lodash';
	import Button from 'primevue/button';
	import Dialog from 'primevue/dialog';
	import { computed, nextTick, onMounted, ref } from 'vue';

	const props = defineProps({
		items: {
			type: String,
			required: true,
		},

		layout: String,
		customTile: Boolean,
		customImage: String,
		customTitle: String,
		customLink: String,
		customLinkName: String
	});
	const tileScrollerElement = ref<HTMLDivElement>(null!);
	const tileScrollerWrapper = ref<HTMLDivElement>(null!);
	const firstGameTile = ref<HTMLDivElement>(null!);
	const lastGameTile = ref<HTMLDivElement>(null!);
	const isFirstGameTileVisible = ref<boolean>(true);
	const isLastGameTileVisible = ref<boolean>(false);

	const tileIndex = ref(0);
	const tileWidth = ref(0);
	const tileWidthMargin = ref(14); // add value pixels to scroll extra, eg margin between tiles
	const translate = computed(() => (tileIndex.value === 0 ? '0' : `${(tileWidth.value + tileWidthMargin.value) * -tileIndex.value}px`));
	const isTranslating = ref<boolean>(false);

	const dialogVisible = ref<boolean>(false);
	const dialogItem = ref<GameTileItemModel>();
	const itemList = computed(() => JSON.parse(props.items) as GameTileItemModel[]);

	const isDragging = ref(false);
	const startX = ref(0);

	function handleMouseDown(e: MouseEvent) {
		isDragging.value = true;
		startX.value = e.clientX;
	}

	function handleMouseMove(e: MouseEvent) {
		if (!isDragging.value) return;

		if (isDragging.value == true && e.pageX < startX.value) {
			if (!isLastGameTileVisible.value && window.innerWidth > 1023) {
				next();
			}
		} else if (isDragging.value == true && e.pageX > startX.value) {
			if (!isFirstGameTileVisible.value && window.innerWidth > 1023) {
				prev();
			}
		}
		isDragging.value = false;
	}

	function handleMouseUp(_e: MouseEvent) {
		isDragging.value = false;
	}

	function showDialog(item: GameTileItemModel) {
		dialogItem.value = item;
		dialogVisible.value = true;
	}

	function prev() {
		if (!isTranslating.value) {
			tileIndex.value = tileIndex.value - 1;
			isTranslating.value = true;
		}
	}
	function next() {
		if (!isTranslating.value) {
			tileIndex.value = tileIndex.value + 1;
			isTranslating.value = true;
		}
	}

	useResizeObserver(tileScrollerElement, () => {
		const gameTile = tileScrollerElement.value.querySelector('.game-tile') as HTMLDivElement;
		tileWidth.value = gameTile?.offsetWidth ?? 0;
	});

	function handleTransitionEnd(e: TransitionEvent) {
		if (e.propertyName === 'transform' && isTranslating.value) {
			if (firstGameTile.value) {
				const rect = firstGameTile.value.getBoundingClientRect();
				const startRect = tileScrollerWrapper.value.getBoundingClientRect().left;
				isFirstGameTileVisible.value = rect.left >= startRect;
			}
			if (lastGameTile.value) {
				const rect = lastGameTile.value.getBoundingClientRect();
				const endRect = tileScrollerWrapper.value.getBoundingClientRect().right;
				isLastGameTileVisible.value = rect.right <= endRect;
			}
			isTranslating.value = false;
		}
	}

	onMounted(async () => {
		await nextTick();
		if (tileScrollerElement.value) {
			const gameTiles = tileScrollerElement.value.querySelectorAll('.game-tile');

			firstGameTile.value = first(gameTiles) as HTMLDivElement;
			lastGameTile.value = last(gameTiles) as HTMLDivElement;
		}
	});
</script>
